import React from 'react'
import './Loader.css'

const Loader = () => {
    return (
        <div className="containers">
            <div className="loading">
                <div className="loading__letter">C</div>
                <div className="loading__letter">A</div>
                <div className="loading__letter">R</div>
                <div className="loading__letter">Z</div>
                <div className="loading__letter">A</div>
                <div className="loading__letter">A</div>
                <div className="loading__letter">R</div>
                <div className="loading__letter">.</div>
                <div className="loading__letter">.</div>
                <div className="loading__letter">.</div>
            </div>
        </div>
    )
}

export default Loader
